export interface ICredentials {
  provider: string
  token: string
}

export class Credentials implements ICredentials {
  provider = 'unknown'

  get token() {
    return this.accessToken
  }

  constructor(public accessToken: string) {}
}

export class FacebookCredentials extends Credentials {
  provider = 'facebook.com'
}

export class ScorocodeCredentials extends Credentials {
  provider = 'scorocode'
}

export interface IApplicationCredentials {
  accessToken: string
  tokenType: string
  idToken: string
  expiresIn: number
  refreshToken: string
}

export class ApplicationCredentials
  implements ICredentials, IApplicationCredentials {
  provider = 'application'
  accessToken: string
  tokenType: string
  idToken: string
  expiresIn: number
  refreshToken: string

  get token() {
    return this.accessToken
  }

  constructor(params: IApplicationCredentials) {
    this.accessToken = params.accessToken
    this.tokenType = params.tokenType
    this.idToken = params.idToken
    this.expiresIn = params.expiresIn
    this.refreshToken = params.refreshToken
  }
}
